import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { currentAuthToken, currentUser, AuthService, User } from '../../../../core/auth';
import { AppState } from '../../../../core/reducers';
import { FormControl } from '@angular/forms';
import { ImpersonationService } from '../../../../core/lists';
import { ImpersonationRoles, ReloadDashboard } from '../../../../core/auth/_actions/auth.actions';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-impersonate-team-user',
  templateUrl: './impersonate-team-user.component.html',
  styleUrls: ['./impersonate-team-user.component.scss'],
})
export class ImpersonateTeamUserComponent implements OnInit {
  currentUser: any;
  authToken;
  subscriptions: Subscription[] = [];
  userctrl = new FormControl('');
  constructor(
    public dialogRef: MatDialogRef<ImpersonateTeamUserComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private impersonationService: ImpersonationService,
    private auth: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.store.pipe(select(currentUser)).subscribe((res) => {
        this.currentUser = res;
      }),
    );
    this.subscriptions.push(
      this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res)),
    );
  }
  getTeamUsers(term?: string): Observable<any> {
    return this.impersonationService.getUsers(term);
  }

  formatUser(user?: User) {
    return user.fullName || '';
  }
  chooseUser() {
    const newRoles = this.userctrl.value.roles?.split(',').map(Number);
    const newUserId = this.userctrl.value.id;
    const newUserName = this.userctrl.value.name;
    this.auth
      .getUser()
      .pipe(take(1))
      .subscribe((value) => {
        const updatedUser = {
          ...value,
          id: newUserId,
          roles: newRoles,
          userName: newUserName,
        };
        this.store.dispatch(
          new ImpersonationRoles({
            impersonationUser: updatedUser,
          }),
        );
      });
    this.store.dispatch(new ReloadDashboard());
    this.router.navigate(['/dashboard'], {});
    this.dialogRef.close();
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
